export default __webpack_public_path__ + "static/media/projTrack2.fb6f4b70.png";